import {useReducer} from 'react'

import {ACTIONS} from './actions.js'
import {initialState, reducer} from './reducer.js'

const useMessagingReducer = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const setInteractionComponent = componentConfig =>
    dispatch({
      type: ACTIONS.SET_INTERACTION_COMPONENT,
      payload: componentConfig
    })

  const setInteractionFunctionResponse = interactionFunctionResponse =>
    dispatch({
      type: ACTIONS.SET_INTERACTION_FUNCTION_RESPONSE,
      payload: interactionFunctionResponse
    })

  const setInteractionInfo = ({params, url}) =>
    dispatch({
      type: ACTIONS.SET_INTERACTION_INFO,
      payload: {params, url}
    })

  const setChannelsIntegrations = channelsIntegrations =>
    dispatch({
      type: ACTIONS.SET_CHANNELS_INTEGRATIONS,
      payload: channelsIntegrations
    })

  const setAdsDetails = adsDetails =>
    dispatch({
      type: ACTIONS.SET_ADS_DETAILS,
      payload: adsDetails
    })

  return {
    state,
    setInteractionComponent,
    setInteractionFunctionResponse,
    setInteractionInfo,
    setChannelsIntegrations,
    setAdsDetails
  }
}

export {useMessagingReducer}
